export default __webpack_public_path__ + "static/media/close_grey_icon.fe3d0f8c.svg";